<template>
    <TxRendererScreenshotArea>
        <CityMap/>
        <CityMapTitle/>
    </TxRendererScreenshotArea>
</template>

<script>
    import CityMap from './CityMap'
    import CityMapTitle from './CityMapTitle'
    import CityMapModule from "../store-mixin";

    export default {
        name: 'CityMapProduct',
        mixins: [CityMapModule()],
        components: {
            CityMap,
            CityMapTitle,
        },
    }
</script>

<style scoped lang="scss">

</style>

